var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', [(_vm.actionStatusCode !== '12') ? _c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Edit Product Damage marked by Finance")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.Backinvestigation
    }
  }, [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), (_vm.actionStatusCode === '12') ? _c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Edit Action pending By Security")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.Backinvestigation
    }
  }, [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('b-form-fieldset', {
    attrs: {
      "label": "AWB Numbers :",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.awbnumber),
      callback: function($$v) {
        _vm.awbnumber = $$v
      },
      expression: "awbnumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "name": "takeActionn",
      "label": "Take Action:<span style='color: red'>*</span> ",
      "label-cols": 2,
      "horizontal": true
    }
  }, [_c('div', [(_vm.statuss == 15) ? _c('b-form-fieldset', {
    attrs: {
      "label-cols": 1,
      "horizontal": true
    }
  }, [_c('b-form-radio', {
    attrs: {
      "options": [{
          text: 'Reject',
          value: '25'
        },
        {
          text: 'Approve',
          value: '24'
        }
      ],
      "value": "0"
    },
    on: {
      "change": function($event) {
        _vm.selectData($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.istakeaction) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("----------- Not Editable ----------- ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "takeActionRadio"
  }, _vm._l((_vm.takeactionlist), function(n, index) {
    return (_vm.statuss != 15) ? _c('div', {
      key: index,
      staticClass: "takeactionradiobtns",
      staticStyle: {
        "padding-right": "2.5%"
      },
      on: {
        "change": function($event) {
          _vm.selectData(n.id, n.label)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.takeActionname),
        expression: "takeActionname"
      }],
      attrs: {
        "type": "radio",
        "name": n.label
      },
      domProps: {
        "value": n.id,
        "checked": _vm._q(_vm.takeActionname, n.id)
      },
      on: {
        "__c": function($event) {
          _vm.takeActionname = n.id
        }
      }
    }), _vm._v("\n                      " + _vm._s(n.label) + "\n                 ")]) : _vm._e()
  }))], 1)])], 1)]), _vm._v(" "), (_vm.statusCode != 21) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Shipment-wise damage proofs:")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, _vm._l((_vm.shippingIdArray), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "id-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openMediaModal(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-wrapper modal-dialog-scrollable",
    attrs: {
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showClientMediaModal),
      callback: function($$v) {
        _vm.showClientMediaModal = $$v
      },
      expression: "showClientMediaModal"
    }
  }, [
    [_c('h5', {
      staticClass: "modal-title"
    }, [_vm._v("Images/Videos proofs:")]), _vm._v(" "), _c('span', {
      staticClass: "close",
      attrs: {
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          _vm.showClientMediaModal = false
        }
      }
    }, [_vm._v("X")])], _vm._v(" "), (_vm.STDassets) ? _c('div', {
      staticClass: "modal-content"
    }, [_c('div', {
      staticClass: "media-container"
    }, [_c('div', {
      staticClass: "image-container"
    }, [_vm._l((_vm.STDassets.clientImages), function(img, index) {
      return [(img.attachment) ? _c('img', {
        staticClass: "media-preview image-preview",
        attrs: {
          "src": img.attachment,
          "alt": "Image Preview"
        },
        on: {
          "error": function (e) { return e.target.src = 'static/img/img-ph.png'; }
        }
      }) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "video-container"
    }, [_vm._l((_vm.STDassets.videourl), function(vid, index) {
      return [(vid.UnboxingVideoProof1) ? _c('video', {
        staticClass: "media-preview video-preview",
        attrs: {
          "src": vid.UnboxingVideoProof1,
          "controls": ""
        }
      }, [_vm._v("\n                            Your browser does not support the video tag.\n                          ")]) : _vm._e()]
    })], 2)])]) : _vm._e()
  ], 2), _vm._v(" "), (_vm.statusCode == 1 && _vm.isActive) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(" Liquid/Fragile:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "damageCategoryData",
      "options": _vm.damageCategoryList,
      "placeholder": "Select",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.damageCategoryData),
      callback: function($$v) {
        _vm.damageCategoryData = $$v
      },
      expression: "damageCategoryData"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatedata()
      }
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-hand-o-up"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1)])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18644706","hasScoped":true}!./src/views/components/EditProductDamage/EditProductDamage.component.html
// module id = 672
// module chunks = 1